/**
 * Fires when the mouse enters a region.
 * @event eventBus#regionEnter
 * @typedef {CustomEvent} RegionEnterEvent
 * @property {Number} detail.regionId the id of the region
 */

/**
 * Fires when the mouse leaves the map.
 * @event eventBus#regionLeave
 * @typedef {CustomEvent} RegionLeaveEvent
 */

/**
 * Fires when an item is selected in the data selector.
 * @event eventBus#rowSelect
 * @typedef {CustomEvent} RowSelectEvent
 * @property {Number} detail.rowIdx the index of the row
 */

/**
 * Fires when a different color gradient is selected.
 * @event eventBus#gradientChange
 * @typedef {CustomEvent} GradientChangeEvent
 */

/**
 * Fires, when the toggle button is clicked.
 * The button toggles the display of the result table.
 * @event eventBus#toggleTable
 * @type {CustomEvent}
 */


/**
 * Central point for initialization of the dom element where modules can attach and dispatch events.
 * @module eventBus
 */
export const eventBus = {

  /**
   * Centralized event dispatcher.
   * @param {String} name
   * @param {Object} detail
   */
  dispatch(name, detail = null) {
    let options = detail;

    if (detail) {
      options = {
        detail: detail
      }
    }
    const event = new CustomEvent(name, options);
    document.body.dispatchEvent(event);
  },

  /**
   * Add an event listener to the bus.
   * @param {String} name name of event to listen to
   * @param {Function} fnc callback
   * @param options
   */
  add(name, fnc, options = null) {
    document.body.addEventListener(name, fnc, options);
  }
};